/*@ngInject*/
const LoadUserDetailsRepository = function (baseCachedRepository) {

    angular.extend(this, baseCachedRepository);

    this.getCacheName = function () {
        return 'loadUserDetailsCache';
    };

    this.getCacheCapacity = function () {
        return 10;
    };

    this.loadUserDetails = function () {
        let url = '/rest/User/profile',
            cacheKey = 'userProfile';

        return this.get(cacheKey, url);
    };
};

angular.module('umCore')
    .service('loadUserDetailsRepository', LoadUserDetailsRepository);
